import { locale } from '..';

const planTypeLabelMap: Record<ChargebeePlanId, string> = {
    CHARGEBEE_PLAN_BASIC:
        locale.enUS.MANAGE_DETECTIONS.DETECTION_SETTINGS.PLAN_TYPE_LABELS.BASIC,
    CHARGEBEE_PLAN_CATALOG_ANALYSIS:
        locale.enUS.MANAGE_DETECTIONS.DETECTION_SETTINGS.PLAN_TYPE_LABELS
            .CATALOG_ANALYSIS,
    CHARGEBEE_PLAN_LITE:
        locale.enUS.MANAGE_DETECTIONS.DETECTION_SETTINGS.PLAN_TYPE_LABELS.LITE,
    CHARGEBEE_PLAN_NEW_BASIC:
        locale.enUS.MANAGE_DETECTIONS.DETECTION_SETTINGS.PLAN_TYPE_LABELS
            .NEW_BASIC,
    CHARGEBEE_PLAN_NEW_PRO:
        locale.enUS.MANAGE_DETECTIONS.DETECTION_SETTINGS.PLAN_TYPE_LABELS
            .NEW_PRO,
    CHARGEBEE_PLAN_PRO:
        locale.enUS.MANAGE_DETECTIONS.DETECTION_SETTINGS.PLAN_TYPE_LABELS.PRO,
    CHARGEBEE_PLAN_RISE:
        locale.enUS.MANAGE_DETECTIONS.DETECTION_SETTINGS.PLAN_TYPE_LABELS.RISE,
    CHARGEBEE_PLAN_SCALE:
        locale.enUS.MANAGE_DETECTIONS.DETECTION_SETTINGS.PLAN_TYPE_LABELS.SCALE,
    CHARGEBEE_PLAN_TRIAL:
        locale.enUS.MANAGE_DETECTIONS.DETECTION_SETTINGS.PLAN_TYPE_LABELS.TRIAL,
    CHARGEBEE_PLAN_PUBLISHER:
        locale.enUS.MANAGE_DETECTIONS.DETECTION_SETTINGS.PLAN_TYPE_LABELS
            .PUBLISHER,
};

export const getPlanTypeLabel = (planType: ChargebeePlanId | null): string => {
    if (planType === null) {
        return locale.enUS.MANAGE_DETECTIONS.DETECTION_SETTINGS.PLAN_TYPE_LABELS
            .UNKNOWN;
    }

    return planTypeLabelMap[planType];
};
